import { AnalyticAppName, AnalyticPlatform } from '../../constants/constants';
export abstract class AnalyticBaseProperties {
  MasterContactId: string;
  AppName: string;
  ClientOS: string;
  DeviceType: string;
  Language: string;
  AppVersion: string;
  Platform: string;
  ReservationId: string;

  constructor() {
    this.MasterContactId = '';
    this.AppName = AnalyticAppName;
    this.ClientOS = '';
    this.DeviceType = '';
    this.Language = '';
    this.AppVersion = '';
    this.Platform = AnalyticPlatform;
    this.ReservationId = '';
  }

  parse(): any {
    return {
      user_id: this.MasterContactId,
      app_name: this.AppName,
      client_os: this.ClientOS,
      device_type: this.DeviceType,
      language: this.Language,
      app_version: this.AppVersion,
      platform: this.Platform,
      reservationId: this.ReservationId
    };
  }
}
